import { productsCategories, productsSlugs } from 'constants/products';

import bgPictureCleanser from 'assets/images/productPages/skincare-collection-cleanser.jpg';
import bgPictureCleanserHover from 'assets/images/productPages/skincare-collection-cleanser-hover.jpg';
import bgPictureMoisturizer from 'assets/images/productPages/skincare-collection-moisturizer.jpg';
import bgPictureMoisturizerHover from 'assets/images/productPages/skincare-collection-moisturizer-hover.jpg';
import bgPictureSerum from 'assets/images/productPages/skincare-collection-serum.jpg';
import bgPictureSerumHover from 'assets/images/productPages/skincare-collection-serum-hover.jpg';
import squaredCleanserPictureHover from 'assets/images/skincare/product-cleanser-hover.jpg';
import squaredCleanserPicture from 'assets/images/skincare/product-d-cleanser.jpg';
import squaredMoisturizerPicture from 'assets/images/skincare/product-d-moisturizer.jpg';
import squaredSerumPicture from 'assets/images/skincare/product-m-serum.jpg';
import squaredMoisturizerPictureHover from 'assets/images/skincare/product-moisturizer-hover.jpg';
import squaredSerumPictureHover from 'assets/images/skincare/product-serum-hover.jpg';

import cleanserPicture from '../images/checkout_cleanser.png';
import cleanserMiniPicture from '../images/checkout_cleanser_mini.png';
import cleanserPictureCap from '../images/checkout_cleanser-cap.png';
import moisturizerPicture from '../images/checkout_moisturizer.png';
import moisturizerMiniPicture from '../images/checkout_moisturizer_mini.png';
import serumPicture from '../images/checkout_serum.png';
import serumMiniPicture from '../images/checkout_serum_mini.png';
import serumPictureCap from '../images/checkout_serum-cap.png';

export const cleanser_mini = { label: 'Cleanser', picture: cleanserMiniPicture };
export const serum_mini = { label: 'Serum', picture: serumMiniPicture };
export const moisturizer_mini = { label: 'Moisturizer', picture: moisturizerMiniPicture };

export const cleanser = {
  capacity: '5.07 fl oz',
  cat: 'core',
  description: 'STEP 1 — Gentle yet effective cleansing for oily, sensitive, and dry skin.',
  label: 'Cleanser',
  picture: cleanserPicture,
  pictureLabels: [
    {
      descriptionBold: '95%',
      description: 'say their skin feels soft\u00a0¹',
    },
    {
      descriptionBold: '91%',
      description: 'say their skin looks clear\u00a0¹',
    },
  ],
  pictureWithCap: cleanserPictureCap,
  bgPicture: bgPictureCleanser,
  bgPictureAlt:
    'A Prose custom face wash bottle with green packaging up against a white and beige backdrop.',
  bgLabelledPicture: bgPictureCleanserHover,
  productSquaredPicture: squaredCleanserPicture,
  productSquaredPictureHover: squaredCleanserPictureHover,
  productPageUrl: '/products/custom-cleanser',
  price: 29,
  subscribed_price: 24.65,
  currency: 'USD',
  is_subscribable: true,
  slug: productsSlugs.CLEANSER,
  tag: 'Custom Skincare',
  type: productsCategories.SKINCARE,
  usage: 'lorem ipsum dolor sit amet',
  usageB: 'Daily',
  cardTag: 'New',
};

export const serum = {
  capacity: '1 fl oz',
  cat: 'core',
  description:
    'STEP 2 - Highly concentrated, intensive care for your specific skin concerns, plus instant hydration and boosted cell turnover.',
  label: 'Serum',
  picture: serumPicture,
  pictureLabels: [
    {
      descriptionBold: '91%',
      description: 'say their skin is firmer\u00a0²',
    },
    {
      descriptionBold: '82%',
      description: 'say wrinkle appearance is reduced\u00a0²',
    },
  ],
  pictureWithCap: serumPictureCap,
  bgPicture: bgPictureSerum,
  bgPictureAlt:
    'A Prose custom face serum container with green packaging up against a white and beige backdrop.',
  bgLabelledPicture: bgPictureSerumHover,
  productSquaredPicture: squaredSerumPicture,
  productSquaredPictureHover: squaredSerumPictureHover,
  productPageUrl: '/products/custom-serum',
  price: 64,
  slug: productsSlugs.SERUM,
  tag: 'Custom Skincare',
  subscribed_price: 54.4,
  currency: 'USD',
  is_subscribable: true,
  type: productsCategories.SKINCARE,
  usage: 'lorem ipsum dolor sit amet',
  usageB: 'Daily',
  cardTag: 'New',
};

export const moisturizer = {
  capacity: '1.7 fl oz',
  cat: 'core',
  description:
    'STEP 3 - Ultra-nourishing, fast-absorbing hydration for strong protection against environmental stressors.',
  label: 'Moisturizer',
  picture: moisturizerPicture,
  pictureLabels: [
    {
      descriptionBold: '100%',
      description: 'say their skin is hydrated\u00a0³',
    },
    {
      descriptionBold: '92%',
      description: 'say their skin looks healthy\u00a0⁴',
    },
  ],
  bgPicture: bgPictureMoisturizer,
  bgPictureAlt:
    'A Prose custom face cream container with green packaging up against a white and beige backdrop.',
  bgLabelledPicture: bgPictureMoisturizerHover,
  productSquaredPicture: squaredMoisturizerPicture,
  productSquaredPictureHover: squaredMoisturizerPictureHover,
  productPageUrl: '/products/custom-moisturizer',
  price: 52,
  subscribed_price: 44.2,
  currency: 'USD',
  is_subscribable: true,
  slug: productsSlugs.MOISTURIZER,
  tag: 'Custom Skincare',
  type: productsCategories.SKINCARE,
  usage: 'lorem ipsum dolor sit amet',
  usageB: 'Daily',
  cardTag: 'New',
};

export const productSlugToProductSkincare = {
  [productsSlugs.SERUM]: serum,
  [productsSlugs.CLEANSER]: cleanser,
  [productsSlugs.MOISTURIZER]: moisturizer,
  [productsSlugs.SERUM_MINI]: serum_mini,
  [productsSlugs.CLEANSER_MINI]: cleanser_mini,
  [productsSlugs.MOISTURIZER_MINI]: moisturizer_mini,
};
